import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getStyles from './styles';
import '../style.css';

const SelectList = ({
  className,
  title,
  value = [],
  setValue,
  options,
  name,
}) => {
  const theme = useTheme();
  const classes = getStyles(theme);

  const handleChange = (name, checked) => {
    if (checked) {
      setValue([...value, name]);
    } else {
      setValue(value.filter((valueName) => valueName !== name));
    }
  };

  return (
    <div className={className}>
      {title && <Typography sx={classes.title}>{title}</Typography>}
      <FormControl fullWidth variant="outlined" sx={classes.formControl}>
        <FormGroup name={name}>
          {options.map((option, key) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={value.includes(option.value)}
                  onChange={({ target: { name, checked } }) => {
                    handleChange(name, checked);
                  }}
                  name={option.value}
                  color="primary"
                />
              }
              label={option.label}
            />
          ))}
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default SelectList;
